/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Container from '../components/Layouts/Container';
import * as buttonStyles from '../components/Button/Button.module.scss';
import * as styles from './HumanitixSlice.module.scss';

const HumanitixSlice = ({ input: { primary: { humanitix_checkout_id, humanitix_event_url } } }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://events.humanitix.com/scripts/widgets/inline.js';
    script.type = 'module';
    script.crossOrigin = 'anonymous';
    script.onerror = () => {
      console.warn('Humanitix widget script failed to load');
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }, []);

  return (
    <Container>
      <div className={styles.humanitix}>
        {humanitix_checkout_id && <iframe data-checkout={humanitix_checkout_id} />}
        {!humanitix_checkout_id && (
          <a
            href={humanitix_event_url}
            target="_blank"
            rel="noopener noreferrer"
            className={buttonStyles.Button}
          >
            Register now
          </a>
        )}
      </div>
    </Container>
  );
};

HumanitixSlice.propTypes = {
  input: PropTypes.shape({
    primary: PropTypes.shape({
      humanitix_checkout_id: PropTypes.string,
      humanitix_event_url: PropTypes.string,
    }),
  }).isRequired,
};

export default HumanitixSlice;
